import * as _ from "underscore";

import * as bookUtils from "shared/bookUtils";
import * as utils from "shared/utils";

interface Options {
  userID: string;
  groupMode: boolean;
}

export const calcTemplateData = (book: any, options: Options) => {
  const categories = _.map(bookUtils.categories, (categoryName) => {
    const category: {
      name: string;
      selected?: boolean;
    } = {
      name: categoryName,
    };
    if (book.category === categoryName) {
      category.selected = true;
    }
    return category;
  });

  const data: {
    voting: boolean;
    userID: string;
    categories: any[];
    upVoted?: boolean;
    downVoted?: boolean;
  } = {
    voting: true,
    userID: options.userID,
    categories: categories,
  };

  if (book.yourVote > 0) {
    data.upVoted = true;
  } else if (book.yourVote < 0) {
    data.downVoted = true;
  }

  const templateData = _.extend(book, data);

  if (templateData.userBook && templateData.userBook.tags) {
    templateData.userBook.tagHash = {};
    _.each(templateData.userBook.tags, (tag) => {
      templateData.userBook.tagHash[tag] = true;
    });

    if (templateData.userBook?.readTo) {
      templateData.readToPercentage = templateData.userBook.tagHash["completed"]
        ? 100
        : Math.round(
            (templateData.userBook.position /
              (templateData.totalWords - 1 + 50)) *
              100
          );
    } else {
      templateData.readToPercentage = 0;
    }
  }

  if (options.groupMode) {
    delete templateData.url;
    templateData.groupMode = true;
  }
  templateData.adminMode = false; // options.stores.user.isGod.value;

  templateData.category = bookUtils.categoryLabel(templateData.category);

  if (book.totalWords) {
    // XXX This conditional shouldn't be necessary, should feed in same data format everywhere
    if (typeof book.totalWords === "string") {
      templateData.totalWordsString = book.totalWords;
    } else {
      templateData.totalWordsString = utils.addCommasToNumber(book.totalWords);
    }
  }

  templateData.totalVotesString =
    book.totalVotes && book.totalVotes >= 1000
      ? (book.totalVotes / 1000).toFixed(1) + "k"
      : book.totalVotes;

  // disable image for now due to bug in /api/getImage
  delete templateData.imageURL;

  return templateData;
};
